<template>
<div>
      <!-- Help - Content -->
      <div class="container g-pt-50 g-pb-70">
        <div class="row">
          <div class="col-md-5 col-lg-3 g-mb-30">
            <!-- Breadcrumbs -->
            <div class="g-pb-10">
                <h2 class="mb-0">FAQ Quick Links</h2>
            </div>
            <!-- End Breadcrumbs -->
            <!-- Nav tabs -->
            <ul class="nav flex-column" role="tablist" data-target="nav-5-3-primary-ver" data-tabs-mobile-type="slide-up-down" data-btn-classes="btn btn-md btn-block rounded-0 u-btn-outline-primary">
              <li v-if="items != null" v-for="(group, index) of items.keys()" class="nav-item">
                <a class="nav-link active g-brd-none g-color-main g-color-primary--hover g-px-0 g-py-5 g-font-size-20" data-toggle="tab" v-on:click="Scroll('#' + group.replace(/\s+/g, '') + '-div')" role="tab">
                  {{ group }}
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link g-brd-none g-color-main g-color-primary--hover g-px-0 g-py-5 g-font-size-20" data-toggle="tab" v-on:click="Scroll('#contactDiv')"  role="tab">
                  Contact Us
                </a>
              </li>
            </ul>
            <!-- End Nav tabs -->
          </div>

          <div class="col-md-12 col-lg-9 g-mb-30">
           <help-services></help-services>
           <help-center :items="items"></help-center>
          </div>
        </div>
      </div>
      <!-- End Help - Content -->
    </div>
</template>
<script>
import HelpServices from "@/components/portal/helpData/HelpServices";
import HelpCenter from "@/components/portal/helpData/HelpCenter";
import Vue from 'vue';
export default {
  components: { HelpServices,
                HelpCenter},
     data() {
         return {
             items: null
         };
     },
  async created() {
        try {
            var _this = this;
            //console.log("Bearer " + localStorage.getItem("token"));
            var response = await fetch(Vue.config.API_ENDPOINT + 'CMS/GetHelpFAQs?portalType=CFS', {
                method: 'get',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            })
            //console.log(response);
            let apiitems = await response.json();
            //console.log("API items");
            apiitems = apiitems.sort((x,y) => (x.sortOrder||99999) - (y.sortOrder||99999));
            //console.log(apiitems);
            let sections = new Set();
            //console.log(sections);
            for (let curItem of apiitems)
            {
                //console.log("API item");
                //console.log(curItem);
                sections.add(curItem.section)
            }
            //let sections = apiitems.reduce((sectionSet, curItem) => sectionSet.add(curItem.section), new Set());
            //console.log(sections);
            this.items = [...sections].reduce((resultMap, curSection) =>
                                resultMap.set(curSection,
                                apiitems.filter(x => x.section == curSection)),
                                new Map());
            //console.log(sections);
            //console.log(this.items);
        } catch(ex) {
            console.log(ex);
        }
  },
  methods: {
    Scroll(id){
      //console.log(id);
      this.$scrollTo(id, 300, {
          el: id,
          offset: -100,
          x: false,
          y: true
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// HelpBlock.vue?9d2828ba